import React, { useState } from 'react';
import axios from 'axios';

const Weather = () => {
  const [city, setCity] = useState('');
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState(null);

  const API_KEY = process.env.REACT_APP_WeatherAPIKEY; // Replace with your OpenWeatherMap API key
  // const API_KEY = '589978418503555b652904db997272bd'; // Replace with your OpenWeatherMap API key
  const fetchWeather = async () => {
    try {
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${API_KEY}`
      );
      setWeather(response.data);
      setError(null);
    } catch (error) {
      setError('City not found. Please enter a valid city name.');
      setWeather(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchWeather();
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input

          type="text"
          placeholder="Enter city name"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          required
          className="border border-gray-400 px-4 py-2 rounded-lg mr-2 focus:outline-none"
          />
        <button type="submit" className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded mt-4 focus:outline-none">
        Get Weather
        </button>
      </form>
      {error && <p className="text-red-500 mt-10">{error}</p>}
      {weather && (
        <div className='mt-10'>
          <h2 className="text-2xl font-bold">Weather in {weather.name}</h2>
          <p className="text-lg">Temperature: {weather.main.temp} °C</p>
          <p className="text-lg">Description: {weather.weather[0].description}</p>
        </div>
      )}
    </div>
  );
};

export default Weather;
